import React, { useState } from "react";
import faqs from "../static/data/faq.json";
import "../sass/main.scss";

export const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleFAQ = (index: number) => {
    setExpandedIndex(prevIndex => prevIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <h1 className="faq-big-heading">FAQ's</h1>
      {faqs.map((item, index) => (
        <div key={index} style={{ border: index === 0 && 0 }} className="faq-item">
          <h1
            onClick={() => toggleFAQ(index)}
            className={`faq-question-heading ${expandedIndex === index ? 'active' : ''}`}
          >
            {item.question}
          </h1>
          <div className={`faq-answer-container ${expandedIndex === index ? 'expanded' : ''}`}>
            <div className="faq-answer-content">
              <div className="faq-list__left">
                {item.answers[0]?.map((ans, i) => {
                  if (typeof ans === "string") {
                    return <p key={i}>{ans}</p>;
                  } else if (typeof ans === "object") {
                    return (
                      <div key={i} className="faq-answer-block">
                        <h3 className="faq-answer-subheading">{ans.title}</h3>
                        <p>{ans.content}</p>
                      </div>
                    );
                  }
                })}
              </div>
              {item.answers[1] && (
                <div className="faq-list__right">
                  {item.answers[1]?.map((ans, i) => (
                    <p key={i}>{ans}</p>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};